import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;

  .close-div {
    padding: 0;
    height: 20px;

    button {
      color: #fff;
      background-color: ${({ theme }) => theme.colors.tertiary_500};
      width: 20px;
      height: 19px;
      border-radius: 100%;
      padding: 0;
      border: none;

      :hover {
        cursor: pointer;
      }
    }
  }
`;
export const Content = styled.div`
  padding: 0.5rem;
  display: flex;

  iframe {
    width: 100%;
    height: 35rem;
  }
`;
